import { html } from 'lit';
import { TemplateResult } from 'lit/development';
import { FilterType } from '../genericTopData/types/types';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { FindingType } from '../../types';

export const EMPTY_VALUE = '--';

export function createAssetsInventoryColumns(
  columns: {
    firstLabel: string;
    firstValue: string;
    firstInventorySmartViewId: string;
    firstFilterType: FilterType;
    firstFilterDataArray: Array<FindingType>;
  }[],
  navigateToInventory: (
    inventorySmartViewId: string,
    filterType: FilterType,
    filterData: string,
    filterDataArray: any[]
  ) => Promise<void>
) {
  return columns.map(column => {
    let firstTemplate: TemplateResult;
    const isClickable = column.firstValue !== EMPTY_VALUE;

    if (isClickable) {
      firstTemplate = html`
        <div class="value clickable" fontSize="${FontSizes.TITLE}" fontWeight="${FontWeights.BOLD}">
          ${column.firstValue}
        </div>
      `;
    } else {
      firstTemplate = html`
        <div class="value" fontSize="${FontSizes.TITLE}" fontWeight="${FontWeights.BOLD}">${EMPTY_VALUE}</div>
      `;
    }
    return html`
      <div
        class="overview-section ${isClickable ? 'clickable' : ''}"
        @click="${async () =>
          await navigateToInventory(
            column.firstInventorySmartViewId,
            column.firstFilterType,
            '',
            column.firstFilterDataArray
          )}"
      >
        <gz-title class="section-title d-flex justify-center" fontSize="16">${column.firstLabel}</gz-title>
        <span class="fs-48 section-value">${firstTemplate}</span>
      </div>
    `;
  });
}
